import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Privacy Policy — SlideGMM AI</h1>
        <p className="update-date">Last updated: November 6, 2025</p>

        <section>
          <h2>1. Overview</h2>
          <p>
            SlideGMM AI ("we", "our", or "us") respects your privacy. 
            This Privacy Policy explains how we collect, use, and protect your information 
            when you use our mobile and web applications.
          </p>
        </section>

        <section>
          <h2>2. Microphone Access</h2>
          <p>
            Our mobile application may request access to your device’s microphone 
            to enable voice-based slide generation and real-time audio commands. 
            Audio input is processed securely and is <strong>never stored or shared</strong> 
            with any third party. This access is solely used for providing interactive 
            features within the app.
          </p>
        </section>

        <section>
          <h2>3. Information We Collect</h2>
          <p>
            We collect only the information necessary to provide our services, 
            including user-generated content, voice input (if you use voice features), 
            and analytics data for performance improvement.
          </p>
        </section>

        <section>
          <h2>4. How We Use Information</h2>
          <ul>
            <li>To generate slides and enhance your content experience.</li>
            <li>To process audio commands for faster workflow.</li>
            <li>To improve our products and maintain system stability.</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We use encryption and secure network protocols to protect your data 
            from unauthorized access, alteration, or disclosure.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Services</h2>
          <p>
            SlideGMM AI may integrate with trusted third-party services such as 
            Firebase or analytics providers, which comply with GDPR and Google Play 
            privacy requirements.
          </p>
        </section>

        <section>
          <h2>7. Contact Us</h2>
          <p>
            For questions about this Privacy Policy, please contact us at:
            <br />
            <a href="mailto:team@appdna.ai">team@appdna.ai</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default Privacy;
